/**
 * @Author: kunnisser
 * @Date: 2020-07-15 10:46:25
 * @LastEditors: kunnisser
 * @LastEditTime: 2021-08-13 09:24:47
 * @FilePath: /app_h5/src/main.js
 * @Description: ---- ----
 */
/*
 * @Author: kunnisser
 * @Date: 2020-07-15 10:46:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-08-12 17:19:46
 * @FilePath: /app_h5/src/main.js
 * @Description: ---- 项目入口文件 ----
 */

import Vue from "vue";
import App from "./App";
import router from "./router";
import VueLazyload from 'vue-lazyload'
import './assets/iconfont/symbols'
import './components/SvgIcon/svg'
import toast from './components/toast/index'
import Vant, { Icon } from 'vant';
import { Area } from 'vant-green';
import 'vant/lib/index.css';

import VueClipboards from 'vue-clipboard2'

import VConsole from "vconsole";
Vue.use(VueClipboards);

Vue.config.productionTip = false;

if (process.env.ENV_CONFIG != 'production') {
  new VConsole();
}

Vue.use(VueLazyload)
Vue.use(toast);
Vue.use(Vant);
Vue.use(Area);
Vue.use(Icon);

const isDesktop = () => {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|OpenHarmony/i.test(
      navigator.userAgent
    )
  ) {
    Vue.prototype.$isDesktop = 0;
  } else {
    Vue.prototype.$isDesktop = 1;
  }
};

isDesktop();

const scaleStrategy = () => {
  // rem 动态设定
  const docEl = document.documentElement;
  const deviceWidth = Vue.prototype.$isDesktop ? 640 : docEl.clientWidth;
  // const [dpr, metaEl] = [
  //   Vue.prototype.$isDesktop ? 1 : window.devicePixelRatio,
  //   docEl.querySelector('meta[name = "viewport"]')
  // ];
  // const scale = 1 / dpr;
  // // 设置dpr 作hack
  // docEl.setAttribute("data-dpr", dpr);
  // metaEl.setAttribute("content", `width=${dpr * deviceWidth},initial-scale=${scale},maximum-scale=${scale},minimum-scale=${scale},user-scalable=no`);
  // const rem = (deviceWidth * dpr) / 10;
  const rem = deviceWidth / 10;
  document.documentElement.style.fontSize = rem + "px";
};

scaleStrategy();

// 设置导航守卫
router.beforeEach((to, from, next) => {
  console.log('当前路由', to.path);
  document.title = to.meta.title;
  next();
});

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js